import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=09803a15&scoped=true&lang=pug&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=09803a15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09803a15",
  null
  
)

/* custom blocks */
import block0 from "./_slug.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./_slug.vue?vue&type=custom&index=1&blockType=router"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsInsuranceLifeInsuranceSummary: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/products/insurance/life-insurance/summary.vue').default,WidgetsAccordion: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/widgets/accordion.vue').default,ProductsInsuranceBenefits: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/products/insurance/benefits.vue').default,SiteAwardsWinner: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/awards-winner.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/feefo.vue').default})
